export const currencyUSDFormatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // @ts-ignore
    trailingZeroDisplay: 'stripIfInteger',
});
